import { API_URL } from "./../../utils/api-utils";

export const url = `${API_URL.Loader}/hubs/upload`;
export const method = "UpdateDownloadHistoryList"